/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AvitoTemplateGroupDto } from './avito-template-group-dto';

/**
 * 
 * @export
 * @interface AvitoFormatOptionsDto
 */
export interface AvitoFormatOptionsDto {
    /**
     * Категория Avito, например \"Одежда, обувь, аксессуары\"
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'category': string;
    /**
     * Значение из SCHEMA.adTypeValues. Внутри значения NBSP (U+00A0).
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'adType': AvitoFormatOptionsDtoAdTypeEnum;
    /**
     * Avito autoload template ID (single-template режим). Взаимоисключающе с `templateGroups`: для одного фида задаётся либо это поле + goodsType/condition/apparelType, либо `templateGroups`. Если не задано ни `templateId`, ни `templateGroups` — auto-режим: бэк сам маппит категорию товара на дефолтный шаблон и ставит condition «Новое с биркой».
     * @type {number}
     * @memberof AvitoFormatOptionsDto
     */
    'templateId'?: AvitoFormatOptionsDtoTemplateIdEnum;
    /**
     * Значение из SCHEMA.goodsTypeValues (single-template режим)
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'goodsType'?: AvitoFormatOptionsDtoGoodsTypeEnum;
    /**
     * Значение из SCHEMA.conditionValues (single-template режим; в multi-режиме condition задаётся на каждую группу)
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'condition'?: AvitoFormatOptionsDtoConditionEnum;
    /**
     * Значение из SCHEMA.apparelTypeValues (single-template режим)
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'apparelType'?: AvitoFormatOptionsDtoApparelTypeEnum;
    /**
     * Multi-template режим: N групп (категория → шаблон) сводятся в один <Ads>-файл — товары разных категорий/полов в одном фиде. Взаимоисключающе с single-полями templateId/goodsType/apparelType. goodsType/apparelType форматтер выводит из схемы выбранного шаблона.
     * @type {Array<AvitoTemplateGroupDto>}
     * @memberof AvitoFormatOptionsDto
     */
    'templateGroups'?: Array<AvitoTemplateGroupDto>;
    /**
     * Целевая аудитория (тип покупателя)
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'targetAudience'?: AvitoFormatOptionsDtoTargetAudienceEnum;
    /**
     * Адрес объекта. Передаётся в тег <Address>. Avito-валидатор требует Address в фиде (даже когда при реальной автозагрузке адрес подставляется из настроек кабинета).
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'address'?: string;
    /**
     * Что делать с длинным Title (> схемного лимита, 50 для sneakers): `truncate` — обрезать по последней word-boundary; `skip` — товар выпадает из фида с ошибкой Title:too_long; `fail` — экспорт падает с ошибкой. Default: `skip`.
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'titleOverflowPolicy'?: AvitoFormatOptionsDtoTitleOverflowPolicyEnum;
    /**
     * Что делать с длинным Description (> схемного лимита, 7500 для sneakers). Семантика идентична `titleOverflowPolicy`. Default: `skip`.
     * @type {string}
     * @memberof AvitoFormatOptionsDto
     */
    'descriptionOverflowPolicy'?: AvitoFormatOptionsDtoDescriptionOverflowPolicyEnum;
}

export const AvitoFormatOptionsDtoAdTypeEnum = {
    ForResale: 'Товар приобретен на продажу',
    FromManufacturer: 'Товар от производителя'
} as const;

export type AvitoFormatOptionsDtoAdTypeEnum = typeof AvitoFormatOptionsDtoAdTypeEnum[keyof typeof AvitoFormatOptionsDtoAdTypeEnum];
export const AvitoFormatOptionsDtoTemplateIdEnum = {
    NUMBER_100368: 100368,
    NUMBER_100369: 100369,
    NUMBER_100370: 100370,
    NUMBER_100371: 100371,
    NUMBER_100372: 100372,
    NUMBER_100373: 100373,
    NUMBER_100374: 100374,
    NUMBER_100375: 100375,
    NUMBER_100376: 100376,
    NUMBER_100377: 100377,
    NUMBER_100378: 100378,
    NUMBER_100379: 100379,
    NUMBER_100380: 100380,
    NUMBER_100381: 100381,
    NUMBER_100383: 100383,
    NUMBER_100384: 100384,
    NUMBER_100385: 100385,
    NUMBER_100386: 100386,
    NUMBER_100387: 100387,
    NUMBER_100388: 100388,
    NUMBER_100389: 100389,
    NUMBER_100390: 100390,
    NUMBER_100391: 100391,
    NUMBER_100392: 100392,
    NUMBER_100393: 100393,
    NUMBER_100394: 100394,
    NUMBER_100395: 100395,
    NUMBER_100396: 100396,
    NUMBER_100397: 100397,
    NUMBER_100398: 100398,
    NUMBER_100399: 100399
} as const;

export type AvitoFormatOptionsDtoTemplateIdEnum = typeof AvitoFormatOptionsDtoTemplateIdEnum[keyof typeof AvitoFormatOptionsDtoTemplateIdEnum];
export const AvitoFormatOptionsDtoGoodsTypeEnum = {
    MaleShoes: 'Мужская обувь',
    FemaleShoes: 'Женская обувь'
} as const;

export type AvitoFormatOptionsDtoGoodsTypeEnum = typeof AvitoFormatOptionsDtoGoodsTypeEnum[keyof typeof AvitoFormatOptionsDtoGoodsTypeEnum];
export const AvitoFormatOptionsDtoConditionEnum = {
    NewWithTag: 'Новое с биркой',
    Excellent: 'Отличное',
    Good: 'Хорошее',
    Satisfactory: 'Удовлетворительное'
} as const;

export type AvitoFormatOptionsDtoConditionEnum = typeof AvitoFormatOptionsDtoConditionEnum[keyof typeof AvitoFormatOptionsDtoConditionEnum];
export const AvitoFormatOptionsDtoApparelTypeEnum = {
    Sneakers: 'Кроссовки',
    AnkleBoots: 'Ботинки и полуботинки',
    Shoes: 'Туфли',
    Keds: 'Кеды',
    BootsAndHalfBoots: 'Сапоги и полусапоги',
    MoccasinsAndLoafers: 'Мокасины и лоферы',
    SportShoes: 'Спортивная обувь',
    UggsValenkiDutiki: 'Угги, валенки, дутики',
    WorkShoes: 'Рабочая обувь',
    RubberShoes: 'Резиновая обувь',
    Sandals: 'Сандалии',
    FlipFlopsAndSlippers: 'Шлёпанцы и сланцы',
    HouseShoes: 'Домашняя обувь',
    SlipOnsAndEspadrilles: 'Слипоны и эспадрильи',
    Boots: 'Сапоги',
    OpenToes: 'Босоножки',
    Booties: 'Ботильоны',
    SneakersAndKeds: 'Кроссовки и кеды',
    HalfBoots: 'Полусапоги',
    BalletFlats: 'Балетки',
    ClogsAndMules: 'Сабо и мюли'
} as const;

export type AvitoFormatOptionsDtoApparelTypeEnum = typeof AvitoFormatOptionsDtoApparelTypeEnum[keyof typeof AvitoFormatOptionsDtoApparelTypeEnum];
export const AvitoFormatOptionsDtoTargetAudienceEnum = {
    Individuals: 'Частные лица',
    Business: 'Бизнес',
    IndividualsAndBusiness: 'Частные лица и бизнес'
} as const;

export type AvitoFormatOptionsDtoTargetAudienceEnum = typeof AvitoFormatOptionsDtoTargetAudienceEnum[keyof typeof AvitoFormatOptionsDtoTargetAudienceEnum];
export const AvitoFormatOptionsDtoTitleOverflowPolicyEnum = {
    Truncate: 'truncate',
    Skip: 'skip',
    Fail: 'fail'
} as const;

export type AvitoFormatOptionsDtoTitleOverflowPolicyEnum = typeof AvitoFormatOptionsDtoTitleOverflowPolicyEnum[keyof typeof AvitoFormatOptionsDtoTitleOverflowPolicyEnum];
export const AvitoFormatOptionsDtoDescriptionOverflowPolicyEnum = {
    Truncate: 'truncate',
    Skip: 'skip',
    Fail: 'fail'
} as const;

export type AvitoFormatOptionsDtoDescriptionOverflowPolicyEnum = typeof AvitoFormatOptionsDtoDescriptionOverflowPolicyEnum[keyof typeof AvitoFormatOptionsDtoDescriptionOverflowPolicyEnum];


